export const STAFF_TRACK = 'Staff'
export const LEADER_TRACK = 'Leader Team'
export const MICROLEARNING = 'Microlearning'
export const LEADER_MEETING = 'Leader Team Meeting'
export const STAFF_MEETING = 'Small-Group Meeting'
export const LESSON_TYPE = 'microlearning'
export const CHOICE_TYPE = 'choiceLesson'
